<template>
  <div
    class="Drop-component"
    @drop="drop"
    @dragenter="dragenter"
    @dragover="dragover"
    @dragleave="dragleave"
    @dragexit="dragexit"
  >
    <slot />
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
import './index.scss';

const props = defineProps({
  drop: Function,
  dragover: Function,
  dragleave: Function,
  dataTransferKey: {
    type: String,
    default: 'dataTransferKey',
  },
  returnEvent: Boolean,
});
function getData(event) {
  if (props.returnEvent) {
    return event;
  }
  const data = event.dataTransfer.getData(props.dataTransferKey);
  return data ? JSON.parse(data) : {};
}
function dragexit() {}
function dragleave() {
  if (props.dragleave) {
    props.dragleave();
  }
}
function dragover(event) {
  event.preventDefault();
  if (props.dragover) {
    props.dragover(getData(event));
  }
}
document.addEventListener(
  'drop',
  event => {
    // 阻止默认动作（如打开一些元素的链接）
    event.preventDefault();
  },
  false
);
function drop(event) {
  // event.preventDefault();
  // event.stopPropagation();
  const data = getData(event);
  if (props.drop) {
    props.drop(data);
  }
  if (props.dragleave) {
    props.dragleave();
  }
}
function dragenter(event) {
  event.preventDefault();
}
</script>
